import { render, staticRenderFns } from "./MediaMessage.vue?vue&type=template&id=8893b586&scoped=true&"
import script from "./MediaMessage.vue?vue&type=script&lang=js&"
export * from "./MediaMessage.vue?vue&type=script&lang=js&"
import style0 from "./MediaMessage.vue?vue&type=style&index=0&id=8893b586&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8893b586",
  null
  
)

export default component.exports